import { QueryClient } from '@tanstack/react-query';
import { isNetworkOrServerError } from './errors';

/**
 * performance-design-web-oberflaeche, Abschnitt "QueryClient-Grundkonfiguration":
 * bis zu 2 Wiederholungen, ausschliesslich bei Netzwerkfehler/5xx, mit
 * exponentiellem Backoff (Basis 300ms). Mutations erhalten keine automatische
 * Wiederholung (tech-stack-decisions-web-oberflaeche: ein wiederholter
 * POST/PUT könnte sonst unbeabsichtigt eine zweite fachliche Wirkung erzeugen).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => isNetworkOrServerError(error) && failureCount < 2,
      retryDelay: (attempt) => 300 * 2 ** attempt,
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    },
    mutations: {
      retry: 0,
    },
  },
});
